import http from './http';

const wpGeodirServices = {
    async getPostPage(body: any): Promise<any> {
        const res = await http.post('api/wp-geodir/get-post-page', body);
        return res;
    },

    async getCategories() {
        const res:any[] = await http.get(`api/wp-geodir/categories`);
        return res;
    },

    async getProgramList(values: any) {
        // const res:any[] = await http.get(`api/wp-geodir/programs/list`,  {
        //     params: values,
        // });
        const res:any[] = await http.get(`api/wp-geodir/search-program`,  {
            params: values,
        });
        return res;
    },

    async getProgram(id: any) {
        const res:any[] = await http.get(`api/wp-geodir/programs/${id}`);
        return res;
    },

    async getProgramListV2(values: any) {
        const res:any[] = await http.get(`api/wp-geodir/programs/list-v2`,  {
            params: values,
        });
        return res;
    },

    async saveProgram(programId: number) {
        const res = await http.post('api/wp-geodir/saved-programs', {
            program_id: programId
        });
        return res;
    },

    async unsaveProgram(programId: number) {
        const res = await http.delete(`api/wp-geodir/saved-programs/${programId}`);
        return res;
    },

    async getSavedPrograms() {
        const res = await http.get('api/wp-geodir/saved-programs');
        return res;
    },

}


export default wpGeodirServices;
